import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import { format, parseISO } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { Vortex } from 'react-loader-spinner'
function MfNewFundOffer() {
    const [currentPage, setCurrentPage] = useState(1);
    const { BaseURL } = useContext(URLstateContext);
    const [dataFandO, setData] = useState([]);
    const [DataMfHoldingdropMfcode, setDataMfHoldingdropMfcode] = useState([]);
    const [CategorymfCode, setCategoryDividend] = useState('-');
    const [valueschemename, setValueschemename] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    let getDataHoldingFandO, PageSize = 5;
    let navigate = useNavigate();

    useEffect(() => {
        setloadingshow(true);
        const getUrl = BaseURL + "MfNewFundOffer";
        fetch(`${getUrl}/NFO/-/8`)
            .then((response) => response.json())
            .then((dataNFO) => {
                getDataHoldingFandO = dataNFO.data;
                setData(getDataHoldingFandO);
                setloadingshow(false);
              // console.log(getDataHoldingFandO, "MfDividendNFO")
            })
            .catch((error) => {
            });
    }, []);

    const currentTableData = useMemo(() => {
        if (dataFandO != null && dataFandO != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (dataFandO != null && dataFandO != []) {
                if (dataFandO.length > 0) {
                    return dataFandO.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, dataFandO]);
    return (
        <>
            <div className='market-inner-common market-mf-main'>
                <div className='market-header'>
                    <h4>New Fund Offer</h4>
                    <span className="moreContent" onClick={()=>{navigate("/MutualFund/New-Fund-Offer")}}>See More</span>
                </div>
                <Container className="add-border table-box">
                <div className='mf-common'>
                <div className='mf-table table-responsive gainer-table'>
                    <table className='table'>
                        <thead>
                            <tr>
                                <th className='text-left'>Scheme</th>
                                <th className='text-right'>Open Date</th>
                                <th className='text-right'>Close Date</th>

                            </tr>
                        </thead>
                        {(dataFandO === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                        <tbody>
                            {(dataFandO != null) && dataFandO.map(
                                ({ Sch_Name, Launc_Date, CLDATE }) => (
                                    <tr>
                                        <td className='text-left'>{Sch_Name}</td>
                                        <td className='text-right'>{format(parseISO(Launc_Date.split('T')[0] != null ? Launc_Date.split('T')[0] :0), 'dd-MMM-yyyy') }</td>
                                        <td className='text-right'>{format(parseISO(CLDATE.split('T')[0] != null ? CLDATE.split('T')[0] :0), 'dd-MMM-yyyy') }</td>

                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                    {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                    {/* {(dataFandO != null && dataFandO != []) ?
                        <Pagination
                            className="pagination-bar_peer"
                            currentPage={currentPage}
                            totalCount={(dataFandO.length != null) ? dataFandO.length : 0}
                            pageSize={PageSize}
                            onPageChange={page => setCurrentPage(page)}
                        /> : <p className="errorPeer"> No Data Found !!! </p>} */}
                </div>
                </div>
                </Container>
            </div>
        </>
    )
}

export default MfNewFundOffer